module.exports = __webpack_public_path__ + "static/logo-c3b7eb5ba9d4d3dd2e7532fe73bdcc6b.png";